// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-options {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 4%;
}

.nav-bar-list .ant-tabs-nav-list {
  background-color: #f5f5f5;
}

.nav-bar-list .ant-tabs-tab-btn {
  color: #000;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #d2042d;
  text-shadow: 0 0 0.25px currentcolor;
}
.nav-bar-list .ant-tabs-tab .ant-tabs-tab-active {
  background-color: #d2042d !important;
}
.filter-drawer .ant-tabs .ant-tabs-ink-bar {
  position: absolute;
  background: #d2042d;
  pointer-events: none;
  width: 5px;
  margin-right: 98%;
}

.filter-drawer .ant-drawer.ant-drawer-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #ffffff;
  pointer-events: auto;
  border-top-left-radius: 22px !important;
  border-top-right-radius: 26px !important;
}
.filter-drawer-radius-class.ant-drawer .ant-drawer-content {
  border-top-left-radius: 22px !important;
  border-top-right-radius: 26px !important;
}
.clear-btn {
  border-radius: 5px;
  background: #f0f0f0 !important;
  display: flex;
  width: 188px;
  height: 50px;
  padding: 8px 34px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  font-weight: 500;
  border: none;
  color: #000 !important;
}
.apply-btn {
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d) !important;
  display: flex;
  width: 188px;
  height: 50px;
  padding: 8px 34px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border: none;
}
.collapse-container-product-type {
  border: none;
  overflow-y: auto;
  height: 46vh;
}

.filter-products-count {
  font-size: 12px;
  color: #888;
}
.view-more-loc {
  display: block;
  margin-top: 8px;
  cursor: pointer;
}
@media (max-width: 430px) {
  .apply-btn {
    width: 160px;
  }
  .clear-btn {
    width: 160px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/filter-drawer/FilterDrawer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".filter-options {\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 4%;\n}\n\n.nav-bar-list .ant-tabs-nav-list {\n  background-color: #f5f5f5;\n}\n\n.nav-bar-list .ant-tabs-tab-btn {\n  color: #000;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #d2042d;\n  text-shadow: 0 0 0.25px currentcolor;\n}\n.nav-bar-list .ant-tabs-tab .ant-tabs-tab-active {\n  background-color: #d2042d !important;\n}\n.filter-drawer .ant-tabs .ant-tabs-ink-bar {\n  position: absolute;\n  background: #d2042d;\n  pointer-events: none;\n  width: 5px;\n  margin-right: 98%;\n}\n\n.filter-drawer .ant-drawer.ant-drawer-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #ffffff;\n  pointer-events: auto;\n  border-top-left-radius: 22px !important;\n  border-top-right-radius: 26px !important;\n}\n.filter-drawer-radius-class.ant-drawer .ant-drawer-content {\n  border-top-left-radius: 22px !important;\n  border-top-right-radius: 26px !important;\n}\n.clear-btn {\n  border-radius: 5px;\n  background: #f0f0f0 !important;\n  display: flex;\n  width: 188px;\n  height: 50px;\n  padding: 8px 34px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  font-weight: 500;\n  border: none;\n  color: #000 !important;\n}\n.apply-btn {\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  display: flex;\n  width: 188px;\n  height: 50px;\n  padding: 8px 34px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border: none;\n}\n.collapse-container-product-type {\n  border: none;\n  overflow-y: auto;\n  height: 46vh;\n}\n\n.filter-products-count {\n  font-size: 12px;\n  color: #888;\n}\n.view-more-loc {\n  display: block;\n  margin-top: 8px;\n  cursor: pointer;\n}\n@media (max-width: 430px) {\n  .apply-btn {\n    width: 160px;\n  }\n  .clear-btn {\n    width: 160px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
